<template>
  <section class="w-full h-full box-border py-5 flex flex-col overflow-hidden">
    <ul class="flex flex-wrap items-center my-1 px-10 box-border overflow-hidden">
      <li class="w-32 mr-3 mb-3">
        <el-select
          v-model="condition.recordId"
          size="small"
          class="w-full-imp"
          placeholder="批次编号"
          clearable
          @change="searchList"
        >
          <el-option v-for="bn of batchNumbers" :key="bn" :label="bn" :value="bn">{{ bn }}</el-option>
        </el-select>
      </li>
      <li class="w-32 mr-3 mb-3">
        <el-input
          v-model="condition.keyword"
          size="small"
          class="w-full-imp"
          placeholder="姓名/手机号"
          clearable
          @change="searchList"
        />
      </li>
      <li class="w-32 mr-3 mb-3">
        <el-select
          v-model="condition.sendStatus"
          size="small"
          class="w-full-imp"
          placeholder="推送状态"
          multiple
          clearable
          @change="searchList"
        >
          <el-option v-for="sl of sendStatusList" :key="sl.value" :label="sl.label" :value="sl.value" />
        </el-select>
      </li>
    </ul>
    <div class="px-10 flex-1 box-border overflow-hidden">
      <data-table
        ref="dataTable"
        class="sms_table w-full h-full overflow-hidden"
        cell-class-name="truncate-table-cell-wrap"
        align="left"
        height="calc(100% - 48px)"
        :data="list"
        :loading="tableLoading"
        :columns="columns"
        :show-page="list.length > 0"
        :page="page"
        selection
        :disabled-all-check="checkAll"
        :show-tooltip="true"
        @selection-change="checkList = $event"
        @size-change="changeSize"
        @pagination-current-change="changeNum"
      >
        <template #sendStatus="{ row }">
          <span>{{ row.sendStatus | sendStatusText }}</span>
        </template>
        <template #opened="{ row }">
          <span v-if="row.opened">是</span>
          <span v-else>否</span>
        </template>
        <template #answerStatus="{ row }">
          <status
            :pointColor="row.answerStatus | answerStatusColor(row.opened)"
            :text="row.answerStatus | answerStatusText(row.opened)"
          />
        </template>
        <template #qsnLink="{ row }">
          <el-button type="text" @click="showAnswer(row)">查看</el-button>
        </template>
        <template #page-left>
          <div class="flex items-center">
            <p class="mr-6 text-medium text-theme-black-650">
              <el-checkbox :disabled="list.length === 0 || checkAll" v-model="checkPageAll">
                已选择&nbsp;<span class="text-theme">{{ checkAll ? page.total : checkList.length }}</span
                >&nbsp;项
              </el-checkbox>
            </p>
            <el-checkbox :disabled="page.total === 0" v-model="checkAll">选择全部</el-checkbox>
            <el-button
              type="primary"
              size="small"
              class="normal-button ml-3"
              :disabled="disabledExport"
              :loading="exportLoading"
              @click="exportList"
              >导出</el-button
            >
          </div>
        </template>
      </data-table>
    </div>
  </section>
</template>

<script>
import { saveAs } from 'file-saver'
import DataTable from '@/components/base/DataTable'
import Status from '@/components/base/Status'
import GlobalConfig from '@/global/config'
import { pageMixins } from '@/mixins/publish'
import { getSmsMessage, getBatchNo, exportExcel, exportExcelByChecks } from '@/api/pay/sms'
import { saColumns, sendStatus, answerStatus } from '../config/sms-sending'

export default {
  name: 'SmsAlready',
  mixins: [pageMixins],
  components: {
    DataTable,
    Status
  },
  inject: {
    source: {
      default: () => ({})
    }
  },
  data() {
    return {
      columns: saColumns,
      sendStatusList: sendStatus,
      batchNumbers: [],
      list: [],
      tableLoading: false,
      condition: {
        recordId: '',
        keyword: '',
        sendStatus: []
      },
      checkAllSource: false,
      exportLoading: false,
      checkList: [],
      notGD: false // 是否忽略tab change时候获取数据(主要针对来自群发记录的发送记录跳转)
    }
  },
  computed: {
    checkPageAll: {
      get() {
        if (this.list.length === 0) return false
        const checkIds = this.checkList.map(m => m.id)
        return this.list.every(e => checkIds.includes(e.id))
      },
      set() {
        const table = this.$refs.dataTable
        if (table) {
          table.toggleAllSelection()
        }
      }
    },
    checkAll: {
      get() {
        if (this.page.total === 0) return false
        return this.checkList.length === this.page.total ? true : this.checkAllSource
      },
      set(bool) {
        if (!bool) {
          this.checkList.splice(0)
          this.$refs.dataTable.clearSelection()
        }
        this.checkAllSource = bool
      }
    },
    disabledExport() {
      if (this.list.length === 0) return true
      return !this.checkAll && this.checkList.length === 0
    }
  },
  filters: {
    sendStatusText(status) {
      if (typeof status !== 'number') return '—'
      return sendStatus[status]?.label || '—'
    },
    answerStatusText(status, opened) {
      if (status === null) {
        return opened ? '已访问' : '未开始'
      }
      return answerStatus[status]?.label || '—'
    },
    answerStatusColor(status, opened) {
      if (status === null) {
        return opened ? '#2775E8' : ''
      }
      return answerStatus[status]?.color || ''
    }
  },
  watch: {
    'source.activeTab': {
      handler(activeTab) {
        if (activeTab === 'alreadySM') {
          if (this.notGD) {
            this.notGD = false
          } else {
            this.condition.recordId = ''
            this.condition.keyword = ''
            this.condition.sendStatus.splice(0)
            this.page.pageSize = 20
            this.searchList()
          }
          this.correctionStyle()
        }
      }
    }
  },
  mounted() {
    this.getBatchNumbers()
  },
  methods: {
    correctionStyle() {
      // 此方法可以矫正表格复选框样式错位的问题
      this.checkAllSource = !this.checkAllSource
      this.$nextTick(() => {
        this.checkAllSource = !this.checkAllSource
      })
    },
    getBatchNumbers() {
      getBatchNo(GlobalConfig.getSurveyId())
        .then(res => {
          const list = res?.data?.data || []
          this.batchNumbers = [...new Set(list)]
        })
        .catch(() => {
          this.$message.error('获取批次编号失败')
        })
    },
    getParams() {
      const params = {
        descs: 'create_time',
        surveyId: GlobalConfig.getSurveyId()
      }
      const { recordId, keyword, sendStatus } = this.condition
      if (recordId !== null && recordId !== undefined && recordId !== '') {
        params.recordId = recordId
      }
      if (keyword) {
        params.keyword = keyword
      }
      if (sendStatus.length > 0) {
        params.sendStatus = sendStatus.join(',')
      }
      return params
    },
    getList() {
      const { currentPage, pageSize } = this.page
      const params = {
        current: currentPage,
        size: pageSize,
        ...this.getParams()
      }
      this.tableLoading = true
      getSmsMessage(params)
        .then(res => {
          const { records, total, current, size } = res?.data?.data || {}
          this.list = records || []
          this.page.total = total ?? 0
          this.page.currentPage = current
          this.page.pageSize = size
          if (this.list.length > 0) {
            this.correctionStyle()
          }
        })
        .catch(e => {
          this.$message.error(e?.msg || '获取已发短信列表失败')
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    exportListByIds() {
      if (this.checkList.length > 0) {
        const req = {
          surveyId: GlobalConfig.getSurveyId(),
          messageIds: this.checkList.map(m => m.id)
        }
        this.exportLoading = true
        exportExcelByChecks(req)
          .then(res => {
            if (res.data.data) {
              saveAs(res.data.data, '已发短信.xlsx')
            }
          })
          .catch(e => {
            this.$message.error(e?.msg || '导出已发短信列表失败')
          })
          .finally(() => {
            this.exportLoading = false
          })
      } else {
        this.$message.warning('请选择至少一条数据')
      }
    },
    exportListByAll() {
      const req = this.getParams()
      this.exportLoading = true
      exportExcel(req)
        .then(res => {
          if (res.data.data) {
            saveAs(res.data.data, '已发短信.xlsx')
          }
        })
        .catch(e => {
          this.$message.error(e?.msg || '导出已发短信列表失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    exportList() {
      if (this.checkAll) {
        this.exportListByAll()
      } else {
        this.exportListByIds()
      }
    },
    showAnswer(item = {}) {
      const surveyId = GlobalConfig.getSurveyId()
      this.$router.push({
        path: `/survey/${surveyId}/data/data-download`,
        query: {
          answerId: item.answerId || ''
        }
      })
    }
  }
}
</script>
